

      var recSwiper = new Swiper('.recommendations-swiper', {
        init: false,
        slidesPerView: 1,
        centerInsufficientSlides: true,
        preventClicks: false,
        preventClicksPropagation: false,
        autoHeight: true,
        pagination: {
          el: '.recomm.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.recomm.swiper-button-next',
          prevEl: '.recomm.swiper-button-prev',
        },
        breakpoints: {
          750: {
            autoHeight: false,
            touchRatio: 0,
            slidesPerView: 4,
            spaceBetween: 45,
          }
        }
      });

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              /*var reccContainer = document.querySelector('.recommendations-container');
              reccContainer.style.display = 'block';*/
              recSwiper.init();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);